if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const wheelBuilder = this.closest('[data-wheel-customizer]');
        const wheelBuilderCart = this.closest('[data-wheel-cart]');
        if (wheelBuilder && wheelBuilderCart) {
          const finishFor = (part) => {
            const preset = wheelBuilder.querySelector(`[data-wheel-part="${part}"][aria-pressed="true"]`);
            if (preset?.dataset.wheelName) return preset.dataset.wheelName;
            const custom = wheelBuilder.querySelector(`[data-wheel-custom="${part}"][aria-pressed="true"]`);
            const select = wheelBuilder.querySelector(`[data-wheel-select="${part}"]`);
            return custom ? select?.selectedOptions?.[0]?.textContent?.trim() || select?.value || '' : '';
          };
          const normalizeFinish = (value) => {
            const normalized = String(value || '').trim().toLowerCase();
            if (normalized === 'shiny chrome' || normalized === 'chrome') return 'chrome';
            if (normalized === 'black') return 'black';
            return normalized ? 'custom' : '';
          };
          let builderData = { models: [] };
          try {
            builderData = JSON.parse(wheelBuilderCart.querySelector('[data-wheel-products]')?.textContent || '{"models":[]}');
          } catch (parseError) {
            builderData = { models: [] };
          }
          const modelSelect = wheelBuilderCart.querySelector('[data-wheel-model]');
          const model = builderData.models?.find((entry) => entry.key === modelSelect?.value) || builderData.models?.[0];
          const rim = finishFor('rim');
          const hub = finishFor('hub');
          const spoke = finishFor('spoke');
          const variant = model?.variants?.find(
            (entry) => entry.available && normalizeFinish(entry.option2) === normalizeFinish(rim) && normalizeFinish(entry.option3) === normalizeFinish(hub)
          );
          if (!variant || !rim || !hub || !spoke) {
            this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
            this.handleErrorMessage(true, 'Choose a rim, spoke, and hub finish before adding this wheelset.');
            return;
          }
          formData.set('id', variant.id);
          formData.set('properties[Bike fitment]', model?.label || modelSelect?.selectedOptions?.[0]?.textContent?.trim() || '');
          formData.set('properties[HUB]', hub);
          formData.set('properties[RIM]', rim);
          formData.set('properties[SPOKE]', spoke);
        }
        const wheelFinishes = this.closest('product-info')?.querySelector('[data-wheel-product-finishes]');
        if (wheelFinishes) {
          const productInfo = this.closest('product-info');
          const optionGroups = productInfo?.querySelectorAll('variant-selects [data-product-ux-option]') || [];
          const selectedOptions = Array.from(optionGroups).map((group) =>
            group.querySelector('input[type="radio"]:checked')?.value || group.querySelector('select')?.value || ''
          );
          let wheelVariants = [];
          try {
            wheelVariants = JSON.parse(wheelFinishes.querySelector('[data-wheel-product-variants]')?.textContent || '[]');
          } catch (parseError) {
            wheelVariants = [];
          }
          const normalizeFinish = (value) => String(value || '').trim().toLowerCase();
          const selectedWheelVariant = wheelVariants.find((variant) =>
            variant.options?.every(
              (value, index) => normalizeFinish(value) === normalizeFinish(selectedOptions[index])
            )
          );
          const selectedFinish = (part) => {
            const option = selectedOptions.find((value, index) => {
              const name = optionGroups[index]?.dataset.productUxOption || '';
              return normalizeFinish(name).includes(part);
            });
            if (!normalizeFinish(option).startsWith('custom')) return option || '';
            return wheelFinishes.querySelector(`[data-wheel-product-custom="${part}"]`)?.value || '';
          };
          const spoke = Array.from(wheelFinishes.querySelectorAll('[data-wheel-product-spoke]')).find(
            (button) => button.getAttribute('aria-checked') === 'true'
          )?.value || '';
          if (selectedWheelVariant) formData.set('id', selectedWheelVariant.id);
          formData.set('properties[HUB]', selectedFinish('hub'));
          formData.set('properties[RIM]', selectedFinish('rim'));
          formData.set('properties[SPOKE]', spoke);
        }
        let mainVariantId = formData.get('id');
        const addonController = this.form.querySelector('tints-addons');
        const addonSelection = addonController?.selection();
        if (addonSelection?.error) {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading__spinner')?.classList.add('hidden');
          this.handleErrorMessage(addonSelection.error);
          return;
        }
        if (addonSelection?.replacement) {
          mainVariantId = String(addonSelection.replacement.id);
          formData.set('id', mainVariantId);
        }
        const selectedAddons = addonSelection?.items || [];
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if (selectedAddons.length) {
          const properties = {};
          formData.forEach((value, key) => {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match && value !== '') properties[match[1]] = value;
          });
          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify({
            items: [
              { id: Number(mainVariantId), quantity: Number(formData.get('quantity') || 1), properties },
              ...selectedAddons
            ],
            sections: formData.get('sections')?.split(',') || [],
            sections_url: formData.get('sections_url') || window.location.pathname
          });
        } else {
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: mainVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!response.key && Array.isArray(response.items)) {
              const addedMainItem =
                response.items.find((item) => String(item.variant_id) === String(mainVariantId)) || response.items[0];
              if (addedMainItem?.key) response.key = addedMainItem.key;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: mainVariantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage(window.addonStrings?.cartError || 'Could not add your items. Please try again.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
